import React from "react";
import "./FullScreenWizardLayout.scss";

const FullScreenWizardLayout = ({
  title,
  subtitle,
  steps = [],
  activeStep = 0,
  onStepChange,
  progress,
  progressLabel = "Completion",
  progressDetail,
  guidance,
  summary,
  footer,
  onClose,
  className = "",
  children,
}) => (
  <section className={`full-screen-wizard ${className}`.trim()}>
    <header className="full-screen-wizard__header">
      <div className="full-screen-wizard__title">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <nav
        className="full-screen-wizard__steps"
        aria-label={`${title} progress`}
      >
        {steps.map((item, index) => (
          <React.Fragment key={item.key || item.title}>
            <button
              type="button"
              className={
                index === activeStep
                  ? "is-active"
                  : index < activeStep
                  ? "is-complete"
                  : ""
              }
              onClick={() => index < activeStep && onStepChange?.(index)}
              aria-current={index === activeStep ? "step" : undefined}
            >
              <b>
                {index < activeStep ? <i className="bx bx-check" /> : index + 1}
              </b>
              <span>
                {item.title}
                <small>{item.description}</small>
              </span>
            </button>
            {index < steps.length - 1 && (
              <i
                className={`full-screen-wizard__step-line ${
                  index < activeStep ? "is-complete" : ""
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </nav>
      {typeof progress === "number" && (
        <aside className="full-screen-wizard__progress">
          <span>
            {progressLabel}
            <b>{progress}%</b>
          </span>
          <i>
            <em style={{ width: `${progress}%` }} />
          </i>
          {progressDetail && <small>{progressDetail}</small>}
        </aside>
      )}
      <button
        type="button"
        className="full-screen-wizard__close"
        onClick={onClose}
        aria-label={`Close ${title}`}
      >
        <i className="bx bx-x" />
      </button>
    </header>
    <div
      className={`full-screen-wizard__content ${
        summary ? "" : "full-screen-wizard__content--without-summary"
      }`.trim()}
    >
      {guidance && (
        <aside className="full-screen-wizard__guidance">{guidance}</aside>
      )}
      <main className="full-screen-wizard__main">{children}</main>
      {summary && (
        <aside className="full-screen-wizard__summary">{summary}</aside>
      )}
    </div>
    <footer className="full-screen-wizard__footer">{footer}</footer>
  </section>
);

export default FullScreenWizardLayout;
